export default __webpack_public_path__ + "953a2b6.png";